import styled from "styled-components";

export const StyledManageActiveResourcesFooter = styled.div<{
  $hideButton: boolean;
}>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  align-items: center;
  justify-content: ${({ $hideButton }) =>
    $hideButton ? "flex-end" : "space-between"};
`;

export const StyledManageActiveResources = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  & .top-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 20px;

    & > .add-ext-collaborator {
      align-self: end;
      justify-content: end;
      align-items: center;
    }

    & .filters-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 20px;

      & .search-container {
        width: 250px;
      }
    }
  }

  & .table-container {
    padding: 0 20px 20px 20px;
  }
`;
